import service from '@/store/services/salary-service';

const state = {
    salaryData: {},
    salaryDataByWeek: {},
    defaultPeriod: {},
    reportSalaryData: {},
    reportExcelSalaryData: {},
    reportRetoucherSalaryData: {},
    reportProRetoucherSalaryData: {},
    weekData: {},
    writePayedRetouchers: {},
    storeAdditionalPayment:{},
    storeNote:{}
};

const mutations = {
    SET_SALARY_DATA: (state, salaryData) => {
      state.salaryData = salaryData;
    },
    SET_SALARY_DATA_BY_WEEK: (state, salaryDataByWeek) => {
        state.salaryDataByWeek = salaryDataByWeek;
    },
    SET_DEFAULT_PERIOD: (state, defaultPeriod) => {
        state.defaultPeriod = defaultPeriod;
    },
    SET_SALARY_REPORT_DATA: (state, reportSalaryData) => {
        state.reportSalaryData = reportSalaryData;
    },
    SET_SALARY_REPORT_EXCEL_DATA: (state, reportExcelSalaryData) => {
        state.reportExcelSalaryData = reportExcelSalaryData;
    },
    SET_SALARY_REPORT_RETOUCHER_DATA: (state, reportRetoucherSalaryData) => {
        state.reportRetoucherSalaryData = reportRetoucherSalaryData;
    },
    SET_SALARY_REPORT_PRO_RETOUCHER_DATA: (state, reportProRetoucherSalaryData) => {
        state.reportProRetoucherSalaryData = reportProRetoucherSalaryData;
    },
    GET_WEEK_DATA: (state, weekData) => {
        state.getWeekData = weekData;
    },
    STORE_WEEK_DATA: (state, storeWeekData) => {
        state.storeWeek = storeWeekData;
    },
    SET_SALARY_WRITE_PAYED: (state, writePayedRetouchers) => {
        state.writePayedRetouchers = writePayedRetouchers;
    },
    STORE_ADDITIONAL_PAYMENT_DATA: (state, storeAdditionalPayment) => {
        state.storeAdditionalPayment = storeAdditionalPayment;
    },
    STORE_NOTE_DATA: (state, storeNote) => {
        state.storeNote = storeNote;
    },
};

const actions = {
    salaryData({dispatch, commit}, params) {
        return service.salaryData(params).then(({ salaryData }) => {
           commit('SET_SALARY_DATA', salaryData);
        });
    },
    salaryDataByWeek({dispatch, commit}, params) {
        return service.salaryDataByWeek(params).then(({salaryDataByWeek}) => {
            commit('SET_SALARY_DATA_BY_WEEK', salaryDataByWeek);
        });
    },
    reportSalaryData({dispatch, commit}, params) {
        return service.reportSalaryData(params).then(({reportSalaryData}) => {
            commit('SET_SALARY_REPORT_DATA', reportSalaryData);
        });
    },
    reportExcelSalaryData({dispatch, commit}, params) {
        return service.reportExcelSalaryData(params).then(({reportExcelSalaryData}) => {
            commit('SET_SALARY_REPORT_EXCEL_DATA', reportExcelSalaryData);
        });
    },
    reportRetoucherSalaryData({dispatch, commit}, params) {
        return service.reportRetoucherSalaryData(params).then(({reportRetoucherSalaryData}) => {
            commit('SET_SALARY_REPORT_RETOUCHER_DATA', reportRetoucherSalaryData);
        });
    },
    reportProRetoucherSalaryData({dispatch, commit}, params) {
        return service.reportProRetoucherSalaryData(params).then(({reportProRetoucherSalaryData}) => {
            commit('SET_SALARY_REPORT_PRO_RETOUCHER_DATA', reportProRetoucherSalaryData);
        });
    },
    getWeekData({dispatch, commit}, params) {
        return service.getWeekData(params).then(({weekData}) => {
            commit('GET_WEEK_DATA', weekData);
        });
    },
    storeWeek({dispatch, commit}, params) {
        return service.storeWeek(params).then(({storeWeekData}) => {
            commit('STORE_WEEK_DATA', storeWeekData);
        });
    },
    defaultPeriod({dispatch, commit}, params) {
        return service.defaultPeriod(params).then(({defaultPeriod}) => {
            commit('SET_DEFAULT_PERIOD', defaultPeriod);
        });
    },
    writePayedRetouchers({dispatch, commit}, params) {
        return service.writePayedRetouchers(params).then(({writePayedRetouchers}) => {
            commit('SET_SALARY_WRITE_PAYED', writePayedRetouchers);
        });
    },
    storeAdditionalPayment({dispatch, commit}, params) {
        return service.storeAdditionalPayment(params).then(({ storeAdditionalPayment}) => {
            commit('STORE_ADDITIONAL_PAYMENT_DATA',  storeAdditionalPayment);
        });
    },
    storeNote({dispatch, commit}, params) {
        return service.storeNote(params).then(({ storeNote}) => {
            commit('STORE_NOTE_DATA',  storeNote);
        });
    },
};

const getters = {
    salaryData: state => state.salaryData,
    salaryDataByWeek: state => state.salaryDataByWeek,
    getWeekData: state => getterKey => state.getWeekData ,
    storeWeek: state => state.storeWeek,
    defaultPeriod: state => state.defaultPeriod,
    reportSalaryData: state => state.reportSalaryData,
    reportExcelSalaryData: state => state.reportExcelSalaryData,
    reportRetoucherSalaryData: state => state.reportRetoucherSalaryData,
    reportProRetoucherSalaryData: state => state.reportProRetoucherSalaryData,
    writePayedRetouchers: state => state.writePayedRetouchers,
    storeAdditionalPayment : state =>state.storeAdditionalPayment,
    storeNote : state =>state.storeNote
};

const salary = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default salary;